import { ControlModes } from '@src/types/Stacks';

export const addControlMode = (
  controlModes: ControlModes[],
): ControlModes[] => {
  return [
    ...controlModes,
    {
      name: `Control Mode ${controlModes.length + 1}`,
      enabled: true,
      sections: [],
    },
  ];
};

export const duplicateControlMode = (
  controlModes: ControlModes[],
  index: number,
): ControlModes[] => {
  const controlModeToDuplicate = controlModes[index];
  // Create a deep copy of the control mode
  const duplicatedControlMode = JSON.parse(
    JSON.stringify(controlModeToDuplicate),
  );

  // Update name to indicate it's a copy
  duplicatedControlMode.name = `${duplicatedControlMode.name} (Copy)`;

  // Insert the duplicated control mode after the original
  return [
    ...controlModes.slice(0, index + 1),
    duplicatedControlMode,
    ...controlModes.slice(index + 1),
  ];
};

export const removeControlMode = (
  controlModes: ControlModes[],
  index: number,
): ControlModes[] => {
  const updatedControlModes = [...controlModes];
  updatedControlModes.splice(index, 1);
  return updatedControlModes;
};

export const updateControlModeName = (
  controlModes: ControlModes[],
  index: number,
  name: string,
): ControlModes[] => {
  const updatedControlModes = [...controlModes];
  updatedControlModes[index] = {
    ...updatedControlModes[index],
    name,
  };
  return updatedControlModes;
};

export const updateControlModeStackAlias = (
  controlModes: ControlModes[],
  index: number,
  name: string,
): ControlModes[] => {
  const updatedControlModes = [...controlModes];
  updatedControlModes[index] = {
    ...updatedControlModes[index],
    stackAlias: name,
  };
  return updatedControlModes;
};

export const updateControlModeEnabled = (
  controlModes: ControlModes[],
  index: number,
  enabled: boolean,
): ControlModes[] => {
  const updatedControlModes = [...controlModes];
  updatedControlModes[index] = {
    ...updatedControlModes[index],
    enabled,
  };
  return updatedControlModes;
};
